import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ActionsWithReviews from 'src/app/molecules/ActionsWithReviews/ActionsWithReviews';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const HeroTextBlock = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl']}
    dataCy='hero-text-block'
  >
    <Stack
      direction='column'
      columns={7}
      columnsXl={9}
      columnsLg={11}
      columnsMd={12}
      gap='spacing-6xl'
      gapSm='spacing-4xl'
    >
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: '2xl',
          text: (
            <>
              Create a community people <i>love</i>
            </>
          ),
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          text: 'Wake up to the possibilities of more energy, growth, and connections. Your future is here—and it’s bright. 😎',
          color: 'text-tertiary',
        }}
      />
      <ActionsWithReviews />
    </Stack>
  </Grid>
);

export default HeroTextBlock;
